<template>
    <div id="frame-general" class="container-frame">
        <h1 id="frame-title">{{ message }}</h1>
        <div id="container-general">
            <div class="general-sous-menu">
                <h2>Création / Mises à jour express d'actes NGAP</h2>
                <h6 class="text-danger">Attention !</h6>
                <p class="border-bottom pb-3">
                    Vous entrez dans une fonction de paramétrage de tables de référence du logiciel. <br />
                    La mise à jour de ces tables peut entrainer des incohérences, voire des dysfonctionnements du logiciel. <br />
                    <span class="text-danger">Attention !</span> <br />
                    Contactez le service technique TransCam avant l'utilisation de ces fonctions.
                </p>
                <p v-if="ngapErrorMessage" class="error-message">{{ ngapErrorMessage }}</p> <!-- Message d'erreur -->
                <p v-if="dateErrorMessage" class="error-message">{{ dateErrorMessage }}</p> <!-- Message d'erreur -->
                <p v-if="ngapSuccesMessage" class="success-message">{{ ngapSuccesMessage }}</p> <!-- Message de succès -->
                <div v-if="isLoadingNgap">
                    <div class="load-wrapp">
                        <div class="load-3">
                            <div class="line"></div>
                            <div class="line"></div>
                            <div class="line"></div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="meme_ligne">
                        <div class="general-group">
                            <label>
                                Prestation
                                <input type="text" v-model="acteNgap.prestation" placeholder="CA" maxlength="4" @input="acteNgap.prestation = acteNgap.prestation.toUpperCase()" @keydown.enter="infosConfigurationAvancee" @blur="infosConfigurationAvancee" class="little-input" />
                            </label>
                        </div>
                        <div class="general-group">
                            <label>
                                Libellé
                                <input type="text" v-model="acteNgap.libelle" placeholder="Consultation approfondie" class="high-input" />
                            </label>
                        </div>
                    </div>
                    <div class="meme_ligne">
                        <div class="general-group">
                            <label>
                                Prix S.S.
                                <input type="text" v-model="acteNgap.prixSs" placeholder="19.99" @keypress="onlyDigits" class="little-input" />
                            </label>
                        </div>
                        <div class="general-group">
                            <label>
                                Début de validité
                                <input type="text" v-model="acteNgap.dateDebutValidite" placeholder="JJ/MM/AAAA" v-date-fr class="mid-input" />
                            </label>
                        </div>
                    </div>
                    <div v-show="!configurationAvanceVisible">
                        <div class="button-group">
                            <button type="button" id="btn_configuration_avance" @click="configurationAvancee">{{ configurationAvanceVisible ? 'Retour configuration express' : 'Configuration avancée' }}</button>
                            <div class="right-buttons">
                                <button type="button" id="btn_fermer" @click="viderChamps">Annuler</button>
                                <button type="button" id="btn_envoyer" @click="confirmerActeNgap">OK</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            <div v-show="configurationAvanceVisible">
                <div class="general-sous-menu">
                    <h2>Configuration avancée</h2>
                    <div class="menu-container">
                        <ul class="menu">
                            <li v-for="(item, index) in menuItems"
                                :key="index"
                                :class="{ active: selectedIndex === index }"
                                @click="selectedIndex = index">
                                {{ item }}
                            </li>
                        </ul>

                        <div class="content-views">

                            <!--Parcours de soins -->

                            <div v-show="selectedIndex === 0">
                                <h4 class="mb-3">Parcours de soins</h4>
                                <div class="row mb-4 border-bottom pb-3">
                                    <!--<div class="col-md-6 mb-2">
                                    <div class="form-check d-flex align-items-center">
                                        <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.prestationRelative" id="soins1" name="monChoix">
                                        <label class="form-check-label" for="soins1">
                                            Prestation relative à la permanence des soins
                                        </label>
                                    </div>
                                </div>-->
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.prestationExclu" id="soins2" name="monChoix">
                                            <label class="form-check-label" for="soins2">
                                                Prestation toujours exclue du parcours de soins
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.prestationNonSoumise" id="soins3" name="monChoix">
                                            <label class="form-check-label" for="soins3">
                                                Prestation non soumise à majoration du ticket modérateur
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <h4 class="mb-3">Dépassements</h4>
                                <div class="row">
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.depassementDA" id="dep1" name="monChoix">
                                            <label class="form-check-label" for="dep1">
                                                Autorise le dépassement Autorisé DA
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.depassementDM" id="dep2" name="monChoix">
                                            <label class="form-check-label" for="dep2">
                                                Autorise le dépassement Maîtrisé DM
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.cumulDepassementAutorise" id="dep3" name="monChoix">
                                            <label class="form-check-label" for="dep3">
                                                Autorise le cumul dépassement Autorisé + Entente directe
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.cumulDepassementMaitrise" id="dep4" name="monChoix">
                                            <label class="form-check-label" for="dep4">
                                                Autorise le cumul dépassement Maîtrisé + exigence particulière (DM)
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Soins médicaux gratuits -->

                            <div v-show="selectedIndex === 1">
                                <h4 class="mb-3">Soins médicaux gratuits</h4>
                                <div class="row mb-4">
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.prestationSmg" id="gratuit1" name="monChoix">
                                            <label class="form-check-label" for="gratuit1">
                                                Prestation pouvant être facturée en SMG
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.prestationObligatoire" id="gratuit2" name="monChoix">
                                            <label class="form-check-label" for="gratuit2">
                                                Prestation soumise obligatoirement à un supplément dérogatoire
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Compatibilité contexte -->

                            <div v-show="selectedIndex === 2">
                                <h4 class="mb-3">Compatibilité contexte</h4>
                                <div class="row mb-4">
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <p>OPTAM / OPTAM-ACO :</p>
                                            <select v-model="indexOPTAM" class="form-control">
                                                <option v-for="(label, key) in compatibiliteContexte" :key="key" :value="key">
                                                    {{ label }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <p>Sans contrat CMU-C ou ACS :</p>
                                            <select v-model="indexCMU" class="form-control">
                                                <option v-for="(label, key) in compatibiliteContexte" :key="key" :value="key">
                                                    {{ label }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <p>Sans contrat Autres</p>
                                            <select v-model="indexAutre" class="form-control">
                                                <option v-for="(label, key) in compatibiliteContexte" :key="key" :value="key">
                                                    {{ label }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Nature assurance -->

                            <div v-show="selectedIndex === 3">
                                <h4 class="mb-3">Nature assurance</h4>
                                <div class="row mb-4">
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.maladie" id="maladie" name="monChoix">
                                            <label class="form-check-label" for="maladie">
                                                Maladie
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.maternite" id="maternite" name="monChoix">
                                            <label class="form-check-label" for="maternite">
                                                Maternité
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.deplacement" id="deplacement" name="monChoix">
                                            <label class="form-check-label" for="deplacement">
                                                Déplacement
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.nuitCheck" id="nuit1" name="monChoix">
                                            <label class="form-check-label" for="nuit1">
                                                Nuit
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.at" id="at" name="monChoix">
                                            <label class="form-check-label" for="at">
                                                AT
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-4 border-bottom pb-3">
                                    <div class="col-md-6 mb-2">
                                        <div class="d-flex align-items-center">
                                            <label for="djf" class="me-2 mb-0">D.J.F.</label>
                                            <input type="text" class="form-control" v-model="infosActeNGAP.djf" @keypress="onlyDigits" id="djf" name="djf">
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="d-flex align-items-center">
                                            <label for="nuit2" class="me-2 mb-0">Nuit</label>
                                            <input type="text" class="form-control" v-model="infosActeNGAP.nuit" @keypress="onlyDigits" id="nuit2" name="nuit2">
                                        </div>
                                    </div>
                                </div>



                                <h4 class="mb-3">Compatibilité</h4>
                                <div class="row mb-4">
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.nonRembourse" id="nonrembourse" name="monChoix">
                                            <label class="form-check-label" for="nonrembourse">
                                                Non remboursé
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.deplacementNonPrescrit" id="nonprescrit" name="monChoix">
                                            <label class="form-check-label" for="nonprescrit">
                                                Déplacement non prescrit
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-4">
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.ententePrealable" id="entente" name="monChoix">
                                            <label class="form-check-label" for="entente">
                                                Entente préalable
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.exigenceParticuliere" id="exigence" name="monChoix">
                                            <label class="form-check-label" for="exigence">
                                                Exigence particulière
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Compatibilité bénéficiaire -->

                            <div v-show="selectedIndex === 4">
                                <h4 class="mb-3">Compatibilité bénéficiaire</h4>
                                <div class="row mb-4 border-bottom pb-3">
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.assure" id="assure" name="monChoix">
                                            <label class="form-check-label" for="assure">
                                                Assuré
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.enfant" id="enfant" name="monChoix">
                                            <label class="form-check-label" for="enfant">
                                                Enfant
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.collateral" id="collateral" name="monChoix">
                                            <label class="form-check-label" for="collateral">
                                                Collatéral/acendant
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.conjoint" id="conjoint" name="monChoix">
                                            <label class="form-check-label" for="conjoint">
                                                Conjoint
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.conjointDivorce" id="divorce" name="monChoix">
                                            <label class="form-check-label" for="divorce">
                                                Conjoint divorcé
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.conjointSepare" id="separe" name="monChoix">
                                            <label class="form-check-label" for="separe">
                                                Conjoint séparé
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.concubin" id="concubin" name="monChoix">
                                            <label class="form-check-label" for="concubin">
                                                Concubin
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.conjointVeuf" id="veuf" name="monChoix">
                                            <label class="form-check-label" for="veuf">
                                                Conjoint veuf
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.autreAyantDroit" id="ayantdroit" name="monChoix">
                                            <label class="form-check-label" for="ayantdroit">
                                                Autre ayant droit
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <h4 class="mb-3">Age bénéficiaires</h4>
                                <div class="row mb-4">
                                    <div class="col-md-6 mb-2">
                                        <div class="d-flex align-items-center">
                                            <label for="age1" class="me-2 mb-0">Age minimum : mois</label>
                                            <input type="text" class="form-control" v-model="infosActeNGAP.ageMinimum" @keypress="onlyDigits" id="age1" name="monChoix">
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="d-flex align-items-center">
                                            <label for="annee1" class="me-2 mb-0">Années : </label>
                                            <input type="text" class="form-control" v-model="infosActeNGAP.anneeMinimum" @keypress="onlyDigits" id="annee1" name="monChoix">
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="d-flex align-items-center">
                                            <label for="age2" class="me-2 mb-0">Age maximum : mois </label>
                                            <input type="text" class="form-control" v-model="infosActeNGAP.ageMaximum" @keypress="onlyDigits" id="age2" name="monChoix">
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="d-flex align-items-center">
                                            <label for="annee2" class="me-2 mb-0">Années : </label>
                                            <input type="text" class="form-control" v-model="infosActeNGAP.anneeMaximum" @keypress="onlyDigits" id="annee2" name="monChoix">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-show="selectedIndex === 5">
                                <h4 class="mb-3">Taux</h4>
                                <div class="row mb-4">
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.rembourseCentPourcent" id="acte" name="monChoix">
                                            <label class="form-check-label" for="acte">
                                                Acte remboursé à 100%
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-4">
                                    <div class="col-md-6 mb-2">
                                        <div class="d-flex align-items-center">
                                            <label for="regime" class="me-2 mb-0">Taux Régime général</label>
                                            <input type="text" class="form-control" v-model="infosActeNGAP.tauxRegimeGeneral" @keypress="onlyDigits" id="regime" name="monChoix">
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="d-flex align-items-center">
                                            <label for="taux" class="me-2 mb-0">Taux CRPCEN</label>
                                            <input type="text" class="form-control" v-model="infosActeNGAP.tauxCRPCEN" @keypress="onlyDigits" id="taux" name="monChoix">
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="d-flex align-items-center">
                                            <label for="tauxmajoration" class="me-2 mb-0">Taux majoration CRPCEN</label>
                                            <input type="text" class="form-control" v-model="infosActeNGAP.tauxMajorationCRPCEN" @keypress="onlyDigits" id="tauxmajoration" name="monChoix">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-show="selectedIndex === 6">
                                <h4 class="mb-3">Complément acte</h4>
                                <div class="row mb-4">
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.coefficient" id="coefficient" name="monChoix">
                                            <label class="form-check-label" for="coefficient">
                                                Coefficient
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-4 border-bottom pb-3">
                                    <div class="col-md-6 mb-2">
                                        <div class="d-flex align-items-center">
                                            <label for="min" class="me-2 mb-0">Min</label>
                                            <div v-if="infosActeNGAP.modifiableMinimum">
                                                <input type="text" class="form-control" v-model="infosActeNGAP.minimum" @keypress="onlyDigits" id="min" name="monChoix">
                                            </div>
                                            <div v-else>
                                                <input type="text" class="form-control" v-model="infosActeNGAP.minimum" @keypress="onlyDigits" id="min" name="monChoix" disabled>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="d-flex align-items-center">
                                            <label for="max" class="me-2 mb-0">Max</label>
                                            <div v-if="infosActeNGAP.modifiableMaximum">
                                                <input type="text" class="form-control" v-model="infosActeNGAP.maximum" @keypress="onlyDigits" id="max" name="monChoix">
                                            </div>
                                            <div v-else>
                                                <input type="text" class="form-control" v-model="infosActeNGAP.maximum" @keypress="onlyDigits" id="max" name="monChoix" disabled>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <h4 class="mb-3">Prescription</h4>
                                <div class="row mb-4 border-bottom pb-3">
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" v-model="infosActeNGAP.prescriptionOui" name="prescriptionOui" id="prescriptionOui" :value="true">
                                            <label class="form-check-label" for="prescriptionOui">Oui</label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" v-model="infosActeNGAP.prescriptionOui" name="prescriptionOui" id="prescriptionNon" :value="false">
                                            <label class="form-check-label" for="prescriptionNon">Non</label>
                                        </div>
                                    </div>
                                </div>


                                <h4 class="mb-3">Type d'acte</h4>
                                <div class="row mb-4 border-bottom pb-3">
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" v-model="typeActe" name="typeActe" id="support" value="support">
                                            <label class="form-check-label" for="support">Support</label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" v-model="typeActe" name="typeActe" id="secondaire" value="secondaire">
                                            <label class="form-check-label" for="secondaire">Secondaire</label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" v-model="typeActe" name="typeActe" id="inddeplacement" value="deplacement">
                                            <label class="form-check-label" for="inddeplacement">Ind. déplacement</label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" v-model="typeActe" name="typeActe" id="kilometrique" value="kilometrique">
                                            <label class="form-check-label" for="kilometrique">Ind kilométrique</label>
                                        </div>
                                    </div>
                                </div>

                                <h4 class="mb-3">Catégorie</h4>
                                <div class="row mb-4">
                                    <div class="col-md-6 mb-2">
                                        <!-- Type de nomenclature -->
                                        <div class="form-check d-flex align-items-center">
                                            <p>Type de nomenclature</p>
                                            <input list="nomenclature-list"
                                                   v-model="indexNomenclature"
                                                   class="form-control"
                                                   style="margin-left: 10px" />
                                            <datalist id="nomenclature-list">
                                                <option v-for="(label, key) in nomenclature" :key="key" :value="label" />
                                            </datalist>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-check d-flex align-items-center">
                                            <input class="form-check-input me-2" type="checkbox" v-model="infosActeNGAP.codageAffine" id="codage" name="monChoix">
                                            <label class="form-check-label" for="codage">
                                                Codage affine
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <!-- Groupe fonctionnel 1 -->
                                        <div class="form-check d-flex align-items-center">
                                            <p>Groupe fonctionnel 1</p>
                                            <input list="fonctionnel1-list"
                                                   v-model="indexFonctionnel1"
                                                   class="form-control"
                                                   style="margin-left: 10px" />
                                            <datalist id="fonctionnel1-list">
                                                <option v-for="(label, key) in fonctionnel1" :key="key" :value="label" />
                                            </datalist>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <!-- Groupe fonctionnel 2 -->
                                        <div class="form-check d-flex align-items-center">
                                            <p>Groupe fonctionnel 2</p>
                                            <input list="fonctionnel2-list"
                                                   v-model="indexFonctionnel2"
                                                   class="form-control"
                                                   style="margin-left: 10px" />
                                            <datalist id="fonctionnel2-list">
                                                <option v-for="(label, key) in fonctionnel2" :key="key" :value="label" />
                                            </datalist>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="button-group">
                            <button type="button" id="btn_configuration_avance" @click="configurationAvancee">{{ configurationAvanceVisible ? 'Retour configuration express' : 'Configuration avancée' }}</button>
                            <div class="right-buttons">
                                <button type="button" id="btn_fermer" @click="defaut">Défaut</button>
                                <button type="button" id="btn_envoyer" @click="confirmerActeNgap">OK</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="general-sous-menu">
                <h2>Création / Mises à jour express d'actes CCAM</h2>
                <div class="content-views">
                    <h6 class="text-danger">Attention !</h6>
                    <p class="border-bottom pb-3">
                        Cet espace permet de créer ou mettre à jour des actes CCAM qui n'existent pas dans le référentiel CCAM fourni avec TransCam.
                        Pour mettre à jour un acte CCAM présent dans le référentiel, vous devez utiliser l'espace "Référentiel CCAM"
                    </p>

                    <p v-if="ccamErrorMessage" class="error-message">{{ ccamErrorMessage }}</p> <!-- Message d'erreur -->
                    <p v-if="ccamSuccesMessage" class="success-message">{{ ccamSuccesMessage }}</p> <!-- Message d'erreur -->

                    <div class="row mb-4 border-bottom pb-3 bg-transparent shadow-none">
                        <div class="col-md-8">
                            <div class="form-check d-flex align-items-center mb-3">
                                <label for="codeACte" class="me-2 mb-0">Code acte CCAM: </label>
                                <input v-if="modifCcam"
                                       list="codeActe-list"
                                       v-model="indexCodeActe"
                                       class="form-control"
                                       maxlength="7"
                                       @input="indexCodeActe = indexCodeActe.toUpperCase()"
                                       @keydown.enter="infosCodeActeCcam"
                                       @blur="infosCodeActeCcam" disabled />
                                <input v-else
                                       list="codeActe-list"
                                       v-model="indexCodeActe"
                                       class="form-control"
                                       maxlength="7"
                                       @input="indexCodeActe = indexCodeActe.toUpperCase()"
                                       @keydown.enter="infosCodeActeCcam"
                                       @blur="infosCodeActeCcam" />
                                <datalist id="codeActe-list">
                                    <option v-for="(label, key) in codeActe" :key="key" :value="label" />
                                </datalist>
                            </div>
                        </div>
                        <div v-if="!supprimerActeLoading" class="col-md-8">
                            <div class="form-check d-flex align-items-center">
                                <label for="libelle" class="me-2 mb-0">Libellé: </label>
                                <textarea v-if="modifCcam" placeholder="Rentrez ici le libellé..." id="libelle" v-model="acteCcam.libelle"></textarea>
                                <textarea v-else placeholder="Rentrez ici le libellé..." id="libelle" v-model="acteCcam.libelle" disabled></textarea>
                            </div>
                        </div>
                    </div>
                    <div v-if="supprimerActeLoading" class="bg-transparent shadow-none">
                        <div class="load-wrapp">
                            <div class="load-3">
                                <div class="line"></div>
                                <div class="line"></div>
                                <div class="line"></div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="row mb-4 border-bottom bg-transparent shadow-none">
                        <div class="col-md-6 mb-2">
                            <div class="form-check d-flex align-items-center">
                                <label for="selectCodeRegroupement" class="me-2 mb-0">Code regroupement</label>
                                <select id="selectCodeRegroupement"
                                        v-model="indexCodeRegroupement"
                                        class="form-control"
                                        :disabled="!modifCcam"
                                        style="margin-left: 10px">
                                    <option value="" disabled selected hidden>Choisir un code</option>
                                    <option v-for="(item, index) in codeRegroupement"
                                            :key="index"
                                            :value="item.valeur">
                                        {{ item.valeur }} - {{ item.libelle }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="col-md-6 mb-2">
                            <div class="form-check d-flex align-items-center">
                                <label for="prix" class="me-2 mb-0">Prix unitaire: </label>
                                <input type="text" class="form-control" id="prix" placeholder="0.00" v-model="acteCcam.prixUnitaire" @keypress="onlyDigits" name="monChoix">
                            </div>
                        </div>
                        <div class="col-md-6 mb-2">
                            <div class="form-check d-flex align-items-center">
                                <label v-if="modifCcam" class="form-check-label" for="ajouteListe">
                                    Ajouter à la liste des tarifs personnels CCAM
                                    <input class="form-check-input me-2" type="checkbox" id="ajouteListe" v-model="acteCcam.tarifPerso" name="monChoix">
                                </label>

                                <label v-else class="form-check-label" for="ajouteListe">
                                    Ajouter à la liste des tarifs personnels CCAM
                                    <input class="form-check-input me-2" type="checkbox" id="ajouteListe" v-model="acteCcam.tarifPerso" name="monChoix" disabled>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div v-show="!supprimerActeLoading" class="bg-transparent shadow-none">
                        <div v-if="SupprimerActeVisible" class="button-group bg-transparent shadow-none d-flex justify-content-center gap-3 mt-3">
                            <p><span class="error-message">Etes-vous sûr de vouloir supprimer le code acte : </span><strong>{{indexCodeActe}}</strong></p>
                            <button type="button" id="btn_fermer" @click="annulerSuppression">Non</button>
                            <button type="button" id="btn_envoyer" @click="supprimerActeCcam">Oui</button>
                        </div>
                        <div v-else class="button-group bg-transparent shadow-none">
                            <button v-if="modifCcam" type="button" id="btn_configuration_avance" @click="confirmerSuppression">Supprimer</button>
                            <button v-else type="button" id="btn_configuration_avance" @click="confirmerSuppression" disabled>Supprimer</button>
                            <div class="right-buttons">
                                <button type="button" id="btn_fermer" @click="viderChampsCCAM">Annuler</button>
                                <button v-if="modifCcam" type="button" id="btn_envoyer" @click="enregistrerActeCcam">OK</button>
                                <button v-else type="button" id="btn_envoyer" @click="enregistrerActeCcam" disabled>OK</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scope>
    @import 'parametre.css';
</style>
<script>
    import { defineComponent } from 'vue';
    import Acte from '../../../script/Acte';

    export default defineComponent({
        data() {
            return {
                message: 'Gestion Actes',
                acteNgap: {
                    prestation: "",
                    libelle: "",
                    prixSs: "",
                    dateDebutValidite: "",
                    modifie: false,
                    modifien: false,
                    modifiet: false,
                    modifiez: false
                },
                configurationAvanceVisible: false,
                ngapErrorMessage: "",
                dateErrorMessage: "",
                ngapSuccesMessage: "",
                ccamErrorMessage: "",
                ccamSuccesMessage: "",
                menuItems: ['Parcours de soins', 'Soins médicaux gratuits', 'Compatibilité contexte', 'Nature assurance / déplacements', 'Bénéficiaires', 'Taux', 'Complément acte'],
                selectedIndex: 0,
                indexOPTAM: 0,
                indexCMU: 0,
                indexAutre: 0,
                indexNomenclature: "",
                indexFonctionnel1: "",
                indexFonctionnel2: "",
                compatibiliteContexte: {
                    0: "",
                    1: "NON",
                    2: "OUI",
                    3: "Sans Dépassement"
                },
                nomenclature: {},
                fonctionnel1: {},
                fonctionnel2: {},
                infosActeNGAP: {},
                infosActeNGAPDefaut: {},
                typeActe: "",
                isLoadingNgap: false,
                codeActe: {},
                indexCodeActe: "",
                codeRegroupement: [],
                indexCodeRegroupement: "",
                acteCcam: {
                    codeActe: "",
                    libelle: "",
                    codeRegroupement: "",
                    prixUnitaire: "",
                    tarifPerso: false
                },
                modifCcam: false,
                supprimerActeLoading: false,
                SupprimerActeVisible: false
            }
        },
        watch: {
            'infosActeNGAP.rembourseCentPourcent'(newValue, oldValue) {
                if (newValue == true) {
                    this.infosActeNGAP.tauxRegimeGeneral = "100";
                    this.infosActeNGAP.tauxCRPCEN = "100";
                } else {
                    this.infosActeNGAP.tauxRegimeGeneral = this.infosActeNGAPDefaut.tauxRegimeGeneral;
                    this.infosActeNGAP.tauxCRPCEN = this.infosActeNGAPDefaut.tauxCRPCEN;
                } 
            },
            'infosActeNGAP.coefficient'(newValue, oldValue) {
                if (newValue == true) {
                    this.infosActeNGAP.modifiableMinimum = true;
                    this.infosActeNGAP.modifiableMaximum = true;
                } else {
                    this.infosActeNGAP.modifiableMinimum = false;
                    this.infosActeNGAP.modifiableMaximum = false;
                }
            }
        },

        computed: {

        },

        methods: {
            viderChamps() {
                this.acteNgap.prestation = "";
                this.acteNgap.libelle = "";
                this.acteNgap.prixSs = "";
                this.acteNgap.dateDebutValidite = "";
                this.infosActeNGAP = {};
                this.infosActeNGAPDefaut = {};
                this.ngapErrorMessage = "";
                this.ngapSuccesMessage = "";
                if (this.configurationAvanceVisible) {
                    this.configurationAvanceVisible = !this.configurationAvanceVisible;
                }
            },
            defaut() {
                this.infosActeNGAP = JSON.parse(JSON.stringify(this.infosActeNGAPDefaut));

                this.acteNgap.libelle = this.infosActeNGAPDefaut.libelle;
                this.acteNgap.prixSs = this.infosActeNGAPDefaut.prixSs;
                this.acteNgap.dateDebutValidite = this.infosActeNGAPDefaut.dateDebutValidite;
                var nomenclatureValeur = this.infosActeNGAPDefaut.nomenclatureValeur;
                var fonctionnelValeur1 = this.infosActeNGAPDefaut.groupeFonctionnelValeur1;
                var fonctionnelValeur2 = this.infosActeNGAPDefaut.groupeFonctionnelValeur2;
                this.indexNomenclature = nomenclatureValeur;
                this.indexFonctionnel1 = fonctionnelValeur1;
                this.indexFonctionnel2 = fonctionnelValeur2;

                if (this.infosActeNGAPDefaut.optam != "") {
                    this.indexOPTAM = parseInt(this.infosActeNGAPDefaut.optam, 10) + 1;
                } else {
                    this.indexOPTAM = 0;
                }

                if (this.infosActeNGAPDefaut.cmuAcs != "") {
                    this.indexCMU = parseInt(this.infosActeNGAPDefaut.cmuAcs, 10) + 1;
                } else {
                    this.indexCMU = 0;
                }

                if (this.infosActeNGAPDefaut.autre != "") {
                    this.indexAutre = parseInt(this.infosActeNGAPDefaut.autre, 10) + 1;
                } else {
                    this.indexAutre = 0;
                }

                if (this.infosActeNGAP.support) {
                    this.typeActe = "support";
                }

                if (this.infosActeNGAP.secondaire) {
                    this.typeActe = "secondaire";
                }

                if (this.infosActeNGAP.indKilometrique) {
                    this.typeActe = "kilometrique";
                }

                if (this.infosActeNGAP.indDeplacement) {
                    this.typeActe = "deplacement";
                }
            },
            async configurationAvancee() {

                if (this.configurationAvanceVisible) {
                    this.configurationAvanceVisible = !this.configurationAvanceVisible;
                    return;
                }

                this.configurationAvanceVisible = !this.configurationAvanceVisible;
            },
            async infosConfigurationAvancee() {
                this.ngapErrorMessage = "";
                this.ngapSuccesMessage = "";

                if (this.acteNgap.prestation == "") {
                    this.ngapErrorMessage = "Veuillez entrer une prestation.";
                    return "stop";
                }

                if (this.acteNgap.dateDebutValidite == "") {
                    this.dateErrorMessage = "";
                }

                if (this.dateErrorMessage) {
                    return "stop";
                }

                try {
                    const response = await Acte.getInfosActeNGAP(this.acteNgap.prestation);
                    this.acteNgap.modifie = false;
                    this.acteNgap.modifien = false;
                    this.acteNgap.modifiet = false;
                    this.acteNgap.modifiez = false;
                    
                    console.log("La réponse du code acte : ", response);
                    if (response == undefined || response == null) {
                        this.ngapErrorMessage = "Erreur lors du chargement de l'acte.";
                        return "stop"; 
                    }

                    this.ngapErrorMessage = response.Item1;
                    if (this.ngapErrorMessage == "" || this.ngapErrorMessage == "Type de prestation invalide ... changée en acte support") {
                       
                    } else {
                        return "stop";  
                    }
                    this.infosActeNGAPDefaut = JSON.parse(JSON.stringify(response.Item2));
                    this.infosActeNGAP = JSON.parse(JSON.stringify(response.Item2));
                    this.acteNgap.libelle = this.infosActeNGAP.libelle;
                    this.acteNgap.prixSs = this.infosActeNGAP.prixSs;
                    this.acteNgap.dateDebutValidite = this.infosActeNGAP.dateDebutValidite;
                    this.nomenclature = Array.isArray(this.infosActeNGAP.nomenclature) ? this.infosActeNGAP.nomenclature : [];
                    this.fonctionnel1 = Array.isArray(this.infosActeNGAP.groupeFonctionnel1) ? this.infosActeNGAP.groupeFonctionnel1 : [];
                    this.fonctionnel2 = Array.isArray(this.infosActeNGAP.groupeFonctionnel2) ? this.infosActeNGAP.groupeFonctionnel2 : [];

                    // Étape 1 : insérer une chaîne vide au début
                    this.nomenclature.unshift("");
                    this.fonctionnel1.unshift("");
                    this.fonctionnel2.unshift("");

                    this.indexNomenclature = this.infosActeNGAP.nomenclatureValeur;
                    this.indexFonctionnel1 = this.infosActeNGAP.groupeFonctionnelValeur1;
                    this.indexFonctionnel2 = this.infosActeNGAP.groupeFonctionnelValeur2;

                    if (this.infosActeNGAP.optam != "") {
                        this.indexOPTAM = parseInt(this.infosActeNGAP.optam, 10) + 1;
                    } else {
                        this.indexOPTAM = 0;
                    }

                    if (this.infosActeNGAP.cmuAcs != "") {
                        this.indexCMU = parseInt(this.infosActeNGAP.cmuAcs, 10) + 1;
                    } else {
                        this.indexCMU = 0;
                    }

                    if (this.infosActeNGAP.autre != "") {
                        this.indexAutre = parseInt(this.infosActeNGAP.autre, 10) + 1;
                    } else {
                        this.indexAutre = 0;
                    }

                    if (this.infosActeNGAP.support) {
                        this.typeActe = "support";
                    }

                    if (this.infosActeNGAP.secondaire) {
                        this.typeActe = "secondaire";
                    }

                    if (this.infosActeNGAP.indKilometrique) {
                        this.typeActe = "kilometrique";
                    }

                    if (this.infosActeNGAP.indDeplacement) {
                        this.typeActe = "deplacement";
                    }


                } catch (error) {
                    console.log("Erreur lors du chargement des données de code acte : ", error);
                    this.ngapErrorMessage = "Erreur lors du chargement des données de code acte : " + error;
                    this.acteNgap.prestation = "";
                    return "stop";
                }
            },
            async confirmerActeNgap() {
                this.ngapErrorMessage = "";
                this.ngapSuccesMessage = "";

                if (this.acteNgap.prestation == "") {
                    this.ngapErrorMessage = "Veuillez entrer une prestation.";
                    return;
                }

                if (this.acteNgap.dateDebutValidite == "") {
                    this.dateErrorMessage = "";
                }

                if (this.dateErrorMessage) {
                    return;
                }
                this.configurationAvanceVisible = false;
                this.isLoadingNgap = true;

                if (this.infosActeNGAP.prescriptionOui == true) {
                    this.infosActeNGAP.prescriptionNon = false;
                } else {
                    this.infosActeNGAP.prescriptionNon = true;
                }

                if (this.typeActe == "support") {
                    this.infosActeNGAP.support = true;
                    this.infosActeNGAP.secondaire = false;
                    this.infosActeNGAP.indKilometrique = false;
                    this.infosActeNGAP.indDeplacement = false;
                }

                if (this.typeActe == "secondaire") {
                    this.infosActeNGAP.support = false;
                    this.infosActeNGAP.secondaire = true;
                    this.infosActeNGAP.indKilometrique = false;
                    this.infosActeNGAP.indDeplacement = false;
                }

                if (this.typeActe == "kilometrique") {
                    this.infosActeNGAP.support = false;
                    this.infosActeNGAP.secondaire = false;
                    this.infosActeNGAP.indKilometrique = true;
                    this.infosActeNGAP.indDeplacement = false;
                }

                if (this.typeActe == "deplacement") {
                    this.infosActeNGAP.support = false;
                    this.infosActeNGAP.secondaire = false;
                    this.infosActeNGAP.indKilometrique = false;
                    this.infosActeNGAP.indDeplacement = true;
                }

                if (this.indexOPTAM != 0) {
                    let indoptam = this.indexOPTAM - 1;
                    this.infosActeNGAP.optam = indoptam.toString();
                } else {
                    this.infosActeNGAP.optam = "";
                }

                if (this.indexCMU != 0) {
                    let indCmu = this.indexCMU - 1;
                    this.infosActeNGAP.cmuAcs = indCmu.toString();;
                } else {
                    this.infosActeNGAP.cmuAcs = "";
                }

                if (this.indexAutre != 0) {
                    let indAutre = this.indexAutre - 1;
                    this.infosActeNGAP.autre = indAutre.toString();;
                } else {
                    this.infosActeNGAP.autre = "";
                }

                if (this.indexNomenclature == undefined) {
                    this.indexNomenclature = "";
                }

                if (this.indexFonctionnel1 == undefined) {
                    this.indexFonctionnel1 = "";
                }

                if (this.indexFonctionnel2 == undefined) {
                    this.indexFonctionnel2 = "";
                }

                this.infosActeNGAP.nomenclatureValeur = this.indexNomenclature;
                this.infosActeNGAP.groupeFonctionnelValeur1 = this.indexFonctionnel1;
                this.infosActeNGAP.groupeFonctionnelValeur2 = this.indexFonctionnel2;

                if (this.infosActeNGAP.ageMaximum !== this.infosActeNGAPDefaut.ageMaximum) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.ageMinimum !== this.infosActeNGAPDefaut.ageMinimum) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.anneeMaximum !== this.infosActeNGAPDefaut.anneeMaximum) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.anneeMinimum !== this.infosActeNGAPDefaut.anneeMinimum) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.assure !== this.infosActeNGAPDefaut.assure) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.at !== this.infosActeNGAPDefaut.at) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.autre !== this.infosActeNGAPDefaut.autre) {
                    // Différence sur autre
                }
                if (this.infosActeNGAP.autreAyantDroit !== this.infosActeNGAPDefaut.autreAyantDroit) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.cmuAcs !== this.infosActeNGAPDefaut.cmuAcs) {
                    // Différence sur cmuAcs
                }
                if (this.infosActeNGAP.codageAffine !== this.infosActeNGAPDefaut.codageAffine) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.coefficient !== this.infosActeNGAPDefaut.coefficient) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.collateral !== this.infosActeNGAPDefaut.collateral) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.concubin !== this.infosActeNGAPDefaut.concubin) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.conjoint !== this.infosActeNGAPDefaut.conjoint) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.conjointDivorce !== this.infosActeNGAPDefaut.conjointDivorce) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.conjointSepare !== this.infosActeNGAPDefaut.conjointSepare) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.conjointVeuf !== this.infosActeNGAPDefaut.conjointVeuf) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.cumulDepassementAutorise !== this.infosActeNGAPDefaut.cumulDepassementAutorise) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.cumulDepassementMaitrise !== this.infosActeNGAPDefaut.cumulDepassementMaitrise) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.dateDebutValidite !== this.infosActeNGAPDefaut.dateDebutValidite) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.depassementDA !== this.infosActeNGAPDefaut.depassementDA) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.depassementDM !== this.infosActeNGAPDefaut.depassementDM) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.deplacement !== this.infosActeNGAPDefaut.deplacement) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.deplacementNonPrescrit !== this.infosActeNGAPDefaut.deplacementNonPrescrit) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.djf !== this.infosActeNGAPDefaut.djf) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.enfant !== this.infosActeNGAPDefaut.enfant) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.ententePrealable !== this.infosActeNGAPDefaut.ententePrealable) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.exigenceParticuliere !== this.infosActeNGAPDefaut.exigenceParticuliere) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.groupeFonctionnelValeur1 !== this.infosActeNGAPDefaut.groupeFonctionnelValeur1) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.groupeFonctionnelValeur2 !== this.infosActeNGAPDefaut.groupeFonctionnelValeur2) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.indDeplacement !== this.infosActeNGAPDefaut.indDeplacement) {
                    // Différence sur indDeplacement
                }
                if (this.infosActeNGAP.indKilometrique !== this.infosActeNGAPDefaut.indKilometrique) {
                    // Différence sur indKilometrique
                }
                if (this.infosActeNGAP.libelle !== this.infosActeNGAPDefaut.libelle) {
                    // Différence sur libelle
                }
                if (this.infosActeNGAP.maladie !== this.infosActeNGAPDefaut.maladie) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.maternite !== this.infosActeNGAPDefaut.maternite) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.maximum !== this.infosActeNGAPDefaut.maximum) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.minimum !== this.infosActeNGAPDefaut.minimum) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.nomenclatureValeur !== this.infosActeNGAPDefaut.nomenclatureValeur) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.nonRembourse !== this.infosActeNGAPDefaut.nonRembourse) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.nuit !== this.infosActeNGAPDefaut.nuit) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.nuitCheck !== this.infosActeNGAPDefaut.nuitCheck) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.optam !== this.infosActeNGAPDefaut.optam) {
                    // Différence sur optam
                }
                if (this.infosActeNGAP.prescriptionNon !== this.infosActeNGAPDefaut.prescriptionNon) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.prescriptionOui !== this.infosActeNGAPDefaut.prescriptionOui) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.prestationExclu !== this.infosActeNGAPDefaut.prestationExclu) {
                    // Différence sur prestationExclu
                }
                if (this.infosActeNGAP.prestationNonSoumise !== this.infosActeNGAPDefaut.prestationNonSoumise) {
                    this.acteNgap.modifiet = true;
                }
                if (this.infosActeNGAP.prestationObligatoire !== this.infosActeNGAPDefaut.prestationObligatoire) {
                    this.acteNgap.modifiez = true;
                }
                if (this.infosActeNGAP.prestationRelative !== this.infosActeNGAPDefaut.prestationRelative) {
                    this.acteNgap.modifiet = true;
                }
                if (this.infosActeNGAP.prestationSmg !== this.infosActeNGAPDefaut.prestationSmg) {
                    this.acteNgap.modifiez = true;
                }
                if (this.infosActeNGAP.prixSs !== this.infosActeNGAPDefaut.prixSs) {
                    // Différence sur prixSs
                }
                if (this.infosActeNGAP.rembourseCentPourcent !== this.infosActeNGAPDefaut.rembourseCentPourcent) {
                    // Différence sur rembourseCentPourcent
                }
                if (this.infosActeNGAP.secondaire !== this.infosActeNGAPDefaut.secondaire) {
                    // Différence sur secondaire
                }
                if (this.infosActeNGAP.support !== this.infosActeNGAPDefaut.support) {
                    // Différence sur support
                }
                if (this.infosActeNGAP.tauxCRPCEN !== this.infosActeNGAPDefaut.tauxCRPCEN) {
                    this.acteNgap.modifie = true;
                }
                if (this.infosActeNGAP.tauxMajorationCRPCEN !== this.infosActeNGAPDefaut.tauxMajorationCRPCEN) {
                    this.acteNgap.modifien = true;
                }
                if (this.infosActeNGAP.tauxRegimeGeneral !== this.infosActeNGAPDefaut.tauxRegimeGeneral) {
                    this.acteNgap.modifie = true;
                }

                const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

                try {
                    const data = {
                        acteBaseNGAP: this.acteNgap,
                        infosComplementairesNGAP: this.infosActeNGAP
                    };

                    console.log("Les données envoyées : ", data);

                    const response = await Acte.postOkActeNGAP(data);
                    await delay(2000);

                    if (response == undefined) {
                        this.isLoadingNgap = false;
                        this.ngapSuccesMessage = "";
                        this.ngapErrorMessage = "Erreur lors de l'enregistrement de l'acte NGAP.";
                    }

                    if (response == "") {
                        this.isLoadingNgap = false;
                        this.ngapErrorMessage = response;
                        await this.infosConfigurationAvancee();
                        this.ngapSuccesMessage = "Acte enregistré avec succès !";
                    } else {
                        this.isLoadingNgap = false;
                        this.ngapSuccesMessage = "";
                        this.ngapErrorMessage = response;
                    }
                    this.isLoadingNgap = false;

                } catch (error) {
                    this.isLoadingNgap = false;
                    console.log("Erreur lors de la validation de l'acte : ", error);
                    this.ngapErrorMessage = "Erreur lors de la validation de l'acte : " + error;
                    this.acteNgap.prestation = "";
                    this.ngapSuccesMessage = "";
                    return;
                }
            },
            async infosCodeActeCcam() {
                this.ccamSuccesMessage = "";
                if (this.indexCodeActe == undefined) {
                    this.ccamErrorMessage = "";
                    return;
                }

                if (this.estCodeActeValide(this.indexCodeActe)) {
                    if (this.indexCodeActe.trim().length != 7) {
                        this.ccamErrorMessage = "Le code acte CCAM doit être composé de 7 caractères : 4 lettres et 3 chiffres";
                        return;
                    }
                } else {
                    this.ccamErrorMessage = "Le code acte CCAM doit être composé de 7 caractères : 4 lettres et 3 chiffres";
                    return;
                }

                try {
                    const response = await Acte.getInfoActeCCAM(this.indexCodeActe);
                    console.log("Réponse code Acte CCAM : ", response);

                    if (response == undefined) {
                        this.ccamErrorMessage = "Erreur lors du chargement de l'acte CCAM.";
                        this.indexCodeActe = "";
                        this.ccamSuccesMessage = "";
                        return;
                    }

                    if (response.Item1 == "") {
                        this.ccamErrorMessage = "";

                        this.codeRegroupement = Array.isArray(response.Item2.listCodeRegroupement) ? response.Item2.listCodeRegroupement : [];
                        this.codeRegroupement.unshift({ valeur: '', libelle: '' });
                        const valeurCodeRegroupement = response.Item2.codeRegroupement ? response.Item2.codeRegroupement.valeur : "";
                        if (valeurCodeRegroupement == undefined || valeurCodeRegroupement == "") {
                            this.indexCodeRegroupement = "";
                        }
                        this.indexCodeRegroupement = valeurCodeRegroupement != undefined ? valeurCodeRegroupement : "";
                        this.acteCcam.libelle = response.Item2.libelle;
                        this.acteCcam.prixUnitaire = response.Item2.prix;
                        this.acteCcam.tarifPerso = response.Item2.tarifsPerso;
                        this.modifCcam = true;
                    } else {
                        this.ccamErrorMessage = "Erreur : " + response.Item1;
                        this.indexCodeActe = "";
                        this.ccamSuccesMessage = "";
                    }

                } catch (error) {
                    console.log("Erreur lors du chargement du code acte CCAM : ", error);
                    this.ccamErrorMessage = "Erreur lors du chargement du code acte CCAM : " + error;
                    this.ccamSuccesMessage = "";
                }
            },
            confirmerSuppression() {
                if (this.modifCcam == false) {
                    return;
                }
                this.SupprimerActeVisible = true;
            },
            async supprimerActeCcam() {
                if (this.modifCcam == false) {
                    return;
                }

                this.ccamSuccesMessage = "";
                this.ccamErrorMessage = "";
                const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
                this.supprimerActeLoading = true;

                try {
                    let response = await Acte.postSupprimeActeCCAM(this.indexCodeActe, this.acteCcam.prixUnitaire);
                    await delay(2000);
                    if (response == "") {
                        this.supprimerActeLoading = false;
                        this.SupprimerActeVisible = false;
                        await this.viderChampsCCAM();
                        this.ccamSuccesMessage = "L'acte CCAM a été supprimé avec succès !";
                    } else {
                        this.supprimerActeLoading = false;
                        this.SupprimerActeVisible = false;
                        this.ccamErrorMessage = "Erreur : " + response;
                    }
                } catch (error) {
                    this.supprimerActeLoading = false;
                    this.SupprimerActeVisible = false;
                    console.log("Erreur lors de la suppression de l'acte CCAM : ", error);
                    this.ccamErrorMessage = "Erreur lors de la suppression de l'acte CCAM.";
                }
            },
            annulerSuppression() {
                this.ccamSuccesMessage = "";
                this.ccamErrorMessage = "";
                this.SupprimerActeVisible = false;
            },
            async enregistrerActeCcam() {
                if (this.modifCcam == false) {
                    return;
                }

                if (this.indexCodeRegroupement == "" || this.indexCodeRegroupement == null || this.indexCodeRegroupement == undefined) {
                    this.ccamErrorMessage = "Le code regroupement est obligatoire.";
                    return;
                }

                this.ccamSuccesMessage = "";
                this.ccamErrorMessage = "";
                this.acteCcam.codeActe = this.indexCodeActe;
                this.acteCcam.codeRegroupement = this.indexCodeRegroupement;

                console.log("l'acte au complet : ", this.acteCcam);

                const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
                this.supprimerActeLoading = true;

                try {
                    let response = await Acte.postEnregistrerActeCCAM(this.acteCcam);
                    await delay(2000);
                    if (response == "") {
                        this.supprimerActeLoading = false;
                        await this.viderChampsCCAM();
                        this.ccamSuccesMessage = "L'acte CCAM a été enregistré avec succès !";
                    } else {
                        this.supprimerActeLoading = false;
                        this.ccamErrorMessage = "Erreur : " + response;
                    }
                } catch (error) {
                    this.supprimerActeLoading = false;
                    console.log("Erreur lors de l'enregistrement de l'acte CCAM : ", error);
                    this.ccamErrorMessage = "Erreur lors de l'enregistrement de l'acte CCAM.";
                }
            },
            async viderChampsCCAM() {
                this.indexCodeActe = "";
                this.indexCodeRegroupement = "";
                this.acteCcam.codeActe = "";
                this.acteCcam.libelle = "";
                this.acteCcam.codeRegroupement = "";
                this.indexCodeRegroupement = "";
                this.acteCcam.prixUnitaire = "";
                this.acteCcam.tarifPerso = false;
                this.codeActe = await Acte.getCodeActe();

                if (this.modifCcam) {
                    this.modifCcam = false;
                }
            },
            estCodeActeValide(code) {
                const regex = /^[A-Za-z]{4}[0-9]{3}$/;
                return regex.test(code);
            },
            formatDate(date) {

                let val = "";

                this.dateErrorMessage = "";
                val = this.acteNgap.dateDebutValidite.trim();

                if (val === "") {
                    this.dateErrorMessage = "";
                    return;
                }

                let jour, mois, annee;

                if (/^\d{6}$/.test(val)) {
                    // Format JJMMYY
                    jour = parseInt(val.slice(0, 2), 10);
                    mois = parseInt(val.slice(2, 4), 10);
                    annee = parseInt(val.slice(4, 6), 10);
                    annee = annee > 50 ? 1900 + annee : 2000 + annee;
                } else if (/^\d{2}\/\d{2}\/\d{2}$/.test(val)) {
                    // Format JJ/MM/AA
                    [jour, mois, annee] = val.split('/').map(Number);
                    annee = annee > 50 ? 1900 + annee : 2000 + annee;
                } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(val)) {
                    // Format JJ/MM/AAAA
                    [jour, mois, annee] = val.split('/').map(Number);
                } else {
                    this.dateErrorMessage = "Format de date invalide. Utilisez JJ/MM/AA, JJ/MM/AAAA ou JJMMYY.";
                    return;
                }

                // Vérifications de validité
                if (jour < 1 || jour > 31 || mois < 1 || mois > 12 || annee < 1900) {
                    this.dateErrorMessage = "Date invalide : jour, mois ou année incorrect.";
                    return;
                }

                const dateSaisie = new Date(annee, mois - 1, jour);
                const aujourdHui = new Date();

                if (dateSaisie > aujourdHui) {
                    this.dateErrorMessage = "La date ne peut pas être dans le futur.";
                    return;
                }
                this.dateErrorMessage = "";
                // Mise en forme finale
                this.acteNgap.dateDebutValidite = `${String(jour).padStart(2, '0')}/${String(mois).padStart(2, '0')}/${annee}`;
                
            },
            filterDateInput(date) {
                this.acteNgap.dateDebutValidite = this.acteNgap.dateDebutValidite.replace(/[^\d\/]/g, '');
            },
            onlyDigits(event) {
                const allowedChars = '0123456789.';
                const key = event.key;

                if (!allowedChars.includes(key)) {
                    event.preventDefault();
                }

                const currentValue = event.target.value;
                if (key === '.' && currentValue.includes('.')) {
                    event.preventDefault();
                }
            }
        },

        props: {

        },
        async mounted() {
            this.codeActe = await Acte.getCodeActe();

            console.log("Les codes actes CCAM : ", this.codeActe);
        }

        ,
        created() {

        }

    });
</script>
